import React from 'react';
import BtnSubmit from '../../Buttons/BtnSubmit';
import '../bitPayment.scss';

const ConfirmBitPaymentComponent = (props) => {
  return <BtnSubmit text='המשך לתשלום ' onclick={props.submitPayment} />;
};

export default ConfirmBitPaymentComponent;
